import {ApiFilter, AppResourceSearch, Logger} from '@milestoneslabs/milestones-js-engine';

export default {
    async setProperties({getters, commit}) {

        try {
            const currentWorkspace = getters.getCurrentWorkspace;
            if (currentWorkspace === null){
                return;
            }

            const propertiesAppCollection = new AppResourceSearch('Property-Instance');
            const filterData = {};
            if (currentWorkspace !== null) {
                filterData.params = {
                    workspace_uuid: currentWorkspace.uuid,
                };
            }
            const propertiesFilter = new ApiFilter(filterData);

            propertiesAppCollection.setSearchData({
                filter: propertiesFilter,
                include: [
                    'addresses',
                ],
            });

            await propertiesAppCollection.search();
            commit('SET_PROPERTIES', propertiesAppCollection);
        } catch (e) {
            console.log(e);
        }
    },

    async addProperty({getters, commit}, property) {
        try {
            const properties = getters.getProperties;
            properties.appResourceCollection.push(property);

            commit('SET_PROPERTIES', properties);
        } catch (e) {
            console.log(e);
        }
    },
};
